import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";

import {
  FooterSection,
  Title,
  Extra,
  Para,
  FooterLink,
  Chat,
  Empty,
  FooterContainer,
  Language,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={24}>
              <Language>{t("Contact")}</Language>
              <Para>{t("Do you have any question? Feel free to reach out.")}</Para>
              <a href="https://cabitrans.es/solicitud-tarifa/">
                <Chat>{t("Let's Chat")}</Chat>
              </a>
              <Empty />
              <Para>
                <strong>Atención al cliente:</strong>
                <br />
                <a
                  href="tel:+34962403354"
                  style={{ color: "#111c44", fontWeight: 700 }}
                >
                  📞 962 40 33 54
                </a>
              </Para>
            </Col>
            <Col lg={8} md={8} sm={12} xs={24}>
              <Title>Servicios destacados</Title>
              <FooterLink as="a" href="#servicios">Envío de Pallets</FooterLink>
              <FooterLink as="a" href="#servicios">Transporte FTL y LTL</FooterLink>
              <FooterLink as="a" href="#servicios">Paquetería nacional</FooterLink>
              <FooterLink as="a" href="#servicios">Paquetería internacional</FooterLink>
            </Col>
            <Col lg={6} md={6} sm={12} xs={24}>
              <Title>CabiTrans</Title>
              <FooterLink as="a" href="https://cabitrans.es">Web corporativa</FooterLink>
              {/* 2026-10-14: al cotizador de One de esta web (antes, al formulario de cabitrans.es). */}
              <FooterLink as="a" href="/cotizador">Solicitar tarifa</FooterLink>
              <FooterLink as="a" href="#precios-pallets">Precios de pallets</FooterLink>
              <FooterLink
                as="button"
                onClick={() => scrollTo("ciudades")}
              >
                Buscador de ciudades
              </FooterLink>
            </Col>
          </Row>
          <Row justify="space-between" style={{ marginTop: "2rem" }}>
            <Col lg={10} md={10} sm={12} xs={24}>
              <Language>{t("Address")}</Language>
              <Para>CabiTrans Global S.L.</Para>
              <Para>Empresas de Transporte Albacete</Para>
              <Para>Provincia de Albacete, España</Para>
            </Col>
            <Col lg={8} md={8} sm={12} xs={24}>
              <Title>{t("Policy")}</Title>
              <FooterLink as="a" href="/aviso-legal">Aviso legal</FooterLink>
              <FooterLink as="a" href="/politica-de-privacidad">Política de privacidad</FooterLink>
              <FooterLink as="a" href="/cookies">Cookies</FooterLink>
              <FooterLink as="button" onClick={() => window.dispatchEvent(new Event("albacete:manage-cookies"))}>Gestionar cookies</FooterLink>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row justify="space-between" align="middle" style={{ paddingTop: "2rem" }}>
            <FooterContainer>
              <span style={{ color: "#111c44", fontWeight: 600, fontSize: "0.9rem" }}>
                © {new Date().getFullYear()} CabiTrans Global S.L. · Empresas de Transporte Albacete
              </span>
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
